<template>
  <div
    :id="id"
    v-loading="loading"
    class="vegaContain"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  ></div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
export default {
  name: "annt",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      vegaDefaultConfig: {
        $schema: "https://vega.github.io/schema/vega/v5.json",
        description:
          "Area charts of stock prices, with an interactive overview and filtered detail views.",
        width: 1024,
        height: 500,
        padding: 0,
        autosize: "fit",
        config: {
          locale: {
            time: {
              periods: ["上午", "下午"],
              days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              shortDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              months: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
              shortMonths: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
            },
          },
        },
        title: { color: "#fff", subtitleColor: "#fff", text: "上市公司临时公告披露趋势" ,anchor: "middle",
          fontSize: 16,
          frame: "group",
          offset: 4,},
        data: [
          {
            name: "annt_raw",
            values: [],
            transform: [
              {
                type: "flatten",
                fields: ["GE8090131T"],
              },
              {
                type: "project",
                fields: [
                  "GE8090131T.GE8090128E",
                  "GE8090131T.GE8090129E",
                  "GE8090131T.GE8090130E",
                ],
                as: ["GE8090128E", "GE8090129E", "GE8090130E"],
              },
              {
                type: "formula",
                expr: "time(datum.GE8090130E)",
                as: "GE8090130E",
              },
              {
                type: "formula",
                expr: "indexof(eventTypes,datum.GE8090128E)",
                as: "typeOrder",
              },
              {
                type: "stack",
                groupby: ["GE8090130E"],
                sort: { field: "typeOrder" },
                field: "GE8090129E",
              },
              {
                type: "collect",
                sort: { field: "GE8090130E" },
              },
            ],
          },
          {
            name: "maxy",
            source: "annt_raw",
            transform: [
              {
                type: "filter",
                expr: "if(detailDomain,datum.GE8090130E>time(detailDomain[0]),false)",
              },
              {
                type: "filter",
                expr: "if(detailDomain,datum.GE8090130E<time(detailDomain[1]),false)",
              },
              {
                type: "aggregate",
                ops: ["sum"],
                fields: ["GE8090129E"],
                groupby: ["GE8090130E"],
                as: ["GE8090129E"],
              },
              {
                type: "aggregate",
                ops: ["max"],
                fields: ["GE8090129E"],
                as: ["GE8090129E"],
              },
            ],
          },
          {
            name: "annt_all",
            source: "annt_raw",
            transform: [
              {
                type: "aggregate",
                fields: ["GE8090129E"],
                ops: ["sum"],
                groupby: ["GE8090130E"],
                as: ["sum"],
              },
              {
                type: "extent",
                field: "GE8090130E",
                signal: "annt_extent",
              },
              {
                type: "collect",
                sort: { field: "GE8090130E" },
              },
            ],
          },
        ],
        signals: [
          {
            name: "detailDomain",
          },
          {
            name: "maxYDomain",
            update: "if(data('maxy').length>0,data('maxy')[0].GE8090129E,null)",
          },
          {
            name: "subheight",
            update: "height*4/5",
          },
          {
            name: "overheight",
            update: "height*1/5",
          },
          {
            name: "eventTypes",
            value: ["交易类", "权益变动类", "融资类", "公司治理类", "其他"],
          },
          {
            name: "dateformat",
            value: {
              year: "%Y",
              quarter: "%B",
              month: "%B",
              week: "%d",
              date: "%d",
              hours: "%d",
              minutes: "%d",
              seconds: "%d",
              milliseconds: "%d",
            },
          },
          {
            name: "width",
            update: "containerSize()[0]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[0]",
              },
            ],
          },
          {
            name: "height",
            update: "containerSize()[1]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[1]",
              },
            ],
          },
        ],
        layout: {
          columns: 1,
        },
        marks: [
          {
            type: "group",
            name: "market_all_stack",
            encode: {
              update: {
                height: { signal: "subheight" },
                width: { signal: "width" },
              },
            },
            scales: [
              {
                name: "xDetail",
                type: "time",
                range: { signal: "[0,width]" },
                domain: { data: "annt_raw", field: "GE8090130E" },
                domainRaw: { signal: "detailDomain" },
                nice: "day",
              },
              {
                name: "yDetail",
                type: "linear",
                range: { signal: "[subheight,0]" },
                domain: { data: "annt_raw", field: "y1" },
                domainMax: { signal: "maxYDomain" },
                nice: true,
                zero: true,
              },
              {
                name: "color",
                type: "ordinal",
                range: { scheme: "set1" },
                domain: { signal: "eventTypes" },
              },
            ],
            legends: [
              {
                fill: "color",
                title: "公告类别",
                titleColor: "#fff",
                labelColor: "#fff",
                offset: 0,
                encode: {
                  symbols: {
                    update: {
                      fillOpacity: { value: 0.8 },
                      stroke: { value: "transparent" },
                    },
                  },
                },
              },
            ],
            axes: [
              {
                orient: "bottom",
                scale: "xDetail",
                labelAngle: 50,
                labelPadding: 10,
                labelColor: "#fff",
                format: { signal: "dateformat" },
              },
              { orient: "left", scale: "yDetail", labelColor: "#fff" },
            ],
            marks: [
              {
                type: "group",
                from: {
                  facet: {
                    name: "series",
                    data: "annt_raw",
                    groupby: "GE8090128E",
                  },
                },
                encode: {
                  update: {
                    height: {
                      field: {
                        group: "height",
                      },
                    },
                    width: {
                      field: {
                        group: "width",
                      },
                    },
                    clip: {
                      value: true,
                    },
                  },
                },
                marks: [
                  {
                    type: "area",
                    from: { data: "series" },
                    encode: {
                      enter: {
                        interpolate: { value: "monotone" },
                        fill: { scale: "color", field: "GE8090128E" },
                      },
                      update: {
                        x: { scale: "xDetail", field: "GE8090130E" },
                        y: { scale: "yDetail", field: "y0" },
                        y2: { scale: "yDetail", field: "y1" },
                        fillOpacity: { value: 1 },
                      },
                      hover: {
                        fillOpacity: { value: 0.5 },
                      },
                    },
                  },
                ],
              },
            ],
          },
          {
            type: "group",
            name: "overview",
            role: "column-footer",
            encode: {
              update: {
                x: { value: 0 },
                y: { signal: "overheight" },
                height: { signal: "overheight" },
                width: { signal: "width" },
                fill: { value: "transparent" },
              },
            },
            signals: [
              {
                name: "brush",
                update:
                  "[scale('xOverview',datetime(year(now()),0,1,0,0,0)),scale('xOverview',annt_extent[1])]",
                on: [
                  {
                    events: "@overview:mousedown",
                    update: "[x(), x()]",
                  },
                  {
                    events: "[@overview:mousedown, window:mouseup] > window:mousemove!",
                    update: "[brush[0], clamp(x(), 0, width)]",
                  },
                  {
                    events: { signal: "delta" },
                    update:
                      "clampRange([anchor[0] + delta, anchor[1] + delta], 0, width)",
                  },
                ],
              },
              {
                name: "anchor",
                value: null,
                on: [{ events: "@brush:mousedown", update: "slice(brush)" }],
              },
              {
                name: "xdown",
                value: 0,
                on: [{ events: "@brush:mousedown", update: "x()" }],
              },
              {
                name: "delta",
                value: 0,
                on: [
                  {
                    events: "[@brush:mousedown, window:mouseup] > window:mousemove!",
                    update: "x() - xdown",
                  },
                ],
              },
              {
                name: "detailDomain",
                push: "outer",
                on: [
                  {
                    events: { signal: "brush" },
                    update: "span(brush) ? invert('xOverview', brush) : null",
                  },
                ],
              },
            ],
            scales: [
              {
                name: "xOverview",
                type: "time",
                range: "width",
                domain: { data: "annt_all", field: "GE8090130E" },
                nice: "day",
              },
              {
                name: "yOverview",
                type: "linear",
                range: { signal: "[overheight,0]" },
                domain: { data: "annt_all", field: "sum" },
                nice: true,
                zero: true,
              },
            ],
            axes: [
              {
                orient: "bottom",
                scale: "xOverview",
                labelColor: "#fff",
                tickCount: { interval: "year", step: 1 },
              },
            ],
            marks: [
              {
                type: "rect",
                interactive: false,
                from: {
                  data: "annt_all",
                },
                encode: {
                  update: {
                    x: {
                      scale: "xOverview",
                      field: "GE8090130E",
                    },
                    width: { scale: "x", band: 1, offset: -1 },
                    y: {
                      scale: "yOverview",
                      field: "sum",
                    },
                    y2: {
                      scale: "yOverview",
                      value: 0,
                    },
                    fill: {
                      value: "steelblue",
                    },
                  },
                },
              },
              {
                type: "rect",
                name: "brush",
                encode: {
                  enter: {
                    y: { value: 0 },
                    height: { signal: "overheight" },
                    fill: { value: "#333" },
                    fillOpacity: { value: 0.2 },
                  },
                  update: {
                    x: { signal: "brush[0]" },
                    x2: { signal: "brush[1]" },
                  },
                },
              },
              {
                type: "rect",
                interactive: false,
                encode: {
                  enter: {
                    y: { value: 0 },
                    height: { signal: "overheight" },
                    width: { value: 1 },
                    fill: { value: "firebrick" },
                  },
                  update: {
                    x: { signal: "brush[0]" },
                  },
                },
              },
              {
                type: "rect",
                interactive: false,
                encode: {
                  enter: {
                    y: { value: 0 },
                    height: { signal: "overheight" },
                    width: { value: 1 },
                    fill: { value: "firebrick" },
                  },
                  update: {
                    x: { signal: "brush[1]" },
                  },
                },
              },
            ],
          },
        ],
      },
      vegaView: {},
      loading: true,
    };
  },
  methods: {
    vegaInit() {
      let width = document.getElementById(this.id).clientWidth;
      let height = document.getElementById(this.id).clientHeight;
      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;
     // apiAxios.apmSyncPost("api000162", {}, {}, (_r) => {
      apiAxios.get(`${config.serverUrl}/cmcf/v1/ldr/themes/M0009/list?limit=10000`, {}, (_r) => {
       // this.vegaDefaultConfig.data[0].values = _r;
       this.vegaDefaultConfig.data[0].values = _r.data.records;
        let aa = vega.parse(this.vegaDefaultConfig);
        var view3 = new vega.View(vega.parse(this.vegaDefaultConfig))
          .renderer("svg")
          .initialize("#" + this.id)
          .hover()
          .run();
        this.loading = false;
        //                 view3.addSignalListener('width', function(name, value) {
        //   console.log('WIDTH: ' + value);
        // });
        //   console.log(_r);
      });
    },
  },
  mounted() {
    // let width = document.body.clientWidth;
    // this.vegaDefaultConfig.width = width;
    // var view3 = new vega.View(vega.parse(this.vegaDefaultConfig))
    //     .renderer('svg')
    //     .initialize('#' + this.id)
    //     .hover()
    //     .run();
    // this.vegaView = view3;
  },
};
</script>

<style lang="less" scoped>
.vegaContain {
  // padding: 5px;
  // // border: solid 1px;
  // margin: 10px;
}
</style>
